import { DateTime } from 'luxon'

import type { UserContextType } from '@/client/context/user'

import { VOLUNTEER_ACTIVITY_TRACKER_START_DATE } from './constants'

// Returns VOLUNTEER_ACTIVITY_TRACKER_START_DATE in the user's tz.
export function getVolunteerActivityTrackerStartDate(user: UserContextType): DateTime {
  return DateTime.local()
    .setZone(user.timezone)
    .set(VOLUNTEER_ACTIVITY_TRACKER_START_DATE)
    .startOf('day')
}
